// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T_HN","rootMobile":"styles_rootMobile__3E2EY"};